import isVariantActive from './is-product-active';

/**
 * Returns a breakdown of variant selection logic;
 * @param {string} selectedSku - selectedSku
 * @param {any[]} variants
 * @returns {{selectedVariant:any,inStockActiveVisibleVariant:any,activeVisbleVariants:any[]}}
 */
function getVariantSelectionBreakdown(selectedSku, variants) {
  // Hide out of stock tiered products
  const isTieredProduct = variants.some((v) => v.baseSku);
  const visibleVariants = variants.filter((v) => !v.baseSku || v.inStock);
  const activeVisbleVariants = visibleVariants.filter(
    (v) => isVariantActive(v?.status) && (!isTieredProduct || v.inStock)
  );

  const inStockActiveVisibleVariant = activeVisbleVariants.find(
    (x) => x.inStock
  );

  return {
    selectedVariant:
      // query
      visibleVariants.find((v) => v.SKU === selectedSku) ??
      // active instock
      inStockActiveVisibleVariant ??
      // any active
      activeVisbleVariants[0] ??
      // master
      visibleVariants.find((v) => v.masterVariant) ??
      // base (non-tiered)
      variants.find((v) => !v.baseSku) ??
      // yolo
      variants[0],
    inStockActiveVisibleVariant,
    activeVisbleVariants,
  };
}

export default getVariantSelectionBreakdown;
